// extracted by mini-css-extract-plugin
export default {"xsmall":"style_xsmall__gS0WW","small":"style_small__88AxM","medium":"style_medium__wVJ-q","large":"style_large__Pcdwq"};